import React  from 'react';
import PropTypes from 'prop-types';
import { Button } from 'Components/Button';
import { doubleDigitDecimalFormatter } from 'Utils/decimalFormatter';
import { classnames } from 'Utils/classnames';
import TextWrapper from 'Components/TextWrapper';
import EnvironmentManager from '../../../../utils/environmentManager';
import getMaxTotalOdd from 'Utils/getMaxTotalOdd';
import { useSelector } from 'react-redux';

const Atrium = ({ betSlip, onClick, isDesktop }) => {
  const isHasTopWin = betSlip?.couponDetails.some(coupon => coupon.hasTopWin);

  const calculateTotalOdds = (couponDetails, useTopWin = true) => {
    let totalOdds = 1;
    couponDetails.forEach(coupon => {
      const bet = coupon.bets[0];
      const topWinOdd = useTopWin && bet.topWinOdds ? parseFloat(bet.topWinOdds) : null;
      const odd = parseFloat(bet.odd);
      totalOdds *= topWinOdd || odd;
    });
    return totalOdds;
  };
  const totalOddsWithTopWin = calculateTotalOdds(betSlip?.couponDetails, true);
  const totalOddsWithoutTopWin = calculateTotalOdds(betSlip?.couponDetails, false);

  const zirveOranSwitch = EnvironmentManager.getMessageText({ key: 'zirveoran_switch' }) == 'true';
  const { topWinEnabled } = useSelector(state => state?.auth?.data);
  const betSlipButtonClass = classnames({
    'btn--atrium': true,
    'btn--atrium--valid': betSlip.isMBSValid && betSlip.isMBSCombinationValid,
    'btn--atrium--hidden': !isDesktop
  });

  const isSystemCoupon = betSlip?.validateData?.data?.columnCount > 1;
  const shouldUseTopWinOdds = isHasTopWin && zirveOranSwitch && !isSystemCoupon;

  const getAtriumOddText = () => {
    if (betSlip.atrium.odd === 0) {
      return '0,00';
    }

    if (!shouldUseTopWinOdds) {
      return doubleDigitDecimalFormatter(betSlip.atrium.odd);
    }

    const oddValue = topWinEnabled ? totalOddsWithTopWin : totalOddsWithoutTopWin;

    return doubleDigitDecimalFormatter(Math.min(oddValue, getMaxTotalOdd()));
  };

  return (
    <>
      <Button title={ 'Maç' } className={ betSlipButtonClass } onClick={ onClick }>
        <div className="atrium-count">
          <b>{ betSlip.atrium.betCount }</b> Maç
        </div>
        <div className="atrium-value">
          <TextWrapper text={ getAtriumOddText() } limit={ '8' } dotted />
        </div>
        { /* <div className="atrium-rate">Oran</div> */ }
      </Button>
    </>
  );
};

Atrium.propTypes = {
  betSlip: PropTypes.object,
  onClick: PropTypes.func,
  isDesktop: PropTypes.bool
};

export default Atrium;
